<fikoyt-uygulama-baslik [altBaslik]="FikoYT.arayuz.altBaslik"
                        (logoTiklandi)="router.navigateByUrl('/')"
                        style="position: fixed;left:0;top:0;right:0;z-index:100;">
    <div class="sag-taraf"
         style="display:flex;align-items:center;gap:8px">
        @if(FikoYT.io.bagli()){ <span>⚡</span> }
        <bildirim-dropdown></bildirim-dropdown>
    </div>
</fikoyt-uygulama-baslik>

<div style="max-width: 960px;align-items: center;margin: 0 auto;padding-top: 4em;">

    <div class="flex flex-row justify-content-center flex-wrap card-container fadeinup animation-duration-500">
        <img src="./simgeler/fikoyt_yazi.png"
             height="72"
             style="filter: drop-shadow(0px 0px 4px #000000);" />
    </div>

    <div class="flex flex-column justify-content-center align-items-center card-container p-2 mt-3">
        @if (u_id) {
        <h4 class="ui horizontal divider header w-30rem max-w-full">
            <i class="project diagram icon"></i>
            Alt Kartlar
        </h4>
        } @else {
        <h4 class="ui horizontal divider header w-30rem max-w-full">
            📢 Paylaşım Sistemi
        </h4>
        }
    </div>

    @if (u_id) {
    <div style="text-align: center;">
        <button class="ui basic small button"
                routerLink="/paylasim">
            <i class="arrow left icon"></i>
            Geri Dön
        </button>
    </div>


    <fikoyt-kart-kok [kart]="ustKart"
                     style="flex: 1;"
                     [kartParametreSetleri]="tumParametreSetleri"
                     [gosterAltKartlarButon]="false"
                     (kartGuncellendi)="ustKart = $event; CD.detectChanges()"></fikoyt-kart-kok>
    }

</div>

<div class="mt-2"
     style="display: flex;flex-direction: column;align-items: center;">

    @if (u_id && altKartSablonlari.length) {
    <fikoyt-paylas-kutusu [kart]="servisProjeler.kart"
                          [parametreSetleri]="altKartSablonlari"
                          [parametreSetiZorunlu]="true"
                          [taslakDevreDisi]="true"
                          (paylasimYapildi)="listeIstek.isteSync();"
                          style="max-width: 520px;width: 100%;"></fikoyt-paylas-kutusu>
    } @else if (!u_id) {
    <fikoyt-paylas-kutusu [kart]="servisProjeler.kart"
                          [parametreSetleri]="tumParametreSetleri"
                          [parametreSetiZorunlu]="false"
                          (paylasimYapildi)="listeIstek.isteSync();"
                          style="max-width: 520px;width: 100%;"></fikoyt-paylas-kutusu>
    } @else if (u_id) {
    <fikoyt-paylas-kutusu [kart]="servisProjeler.kart"
                          [taslakDevreDisi]="true"
                          (paylasimYapildi)="listeIstek.isteSync();"
                          style="max-width: 520px;width: 100%;"></fikoyt-paylas-kutusu>
    }

    <!-- Araç Çubuğu -->
    <div style="max-width: 518px; width: 100%; margin-bottom: 4px; margin-top: 4px;"
         role="toolbar"
         aria-label="Filtre ve sıralama araçları">
        <fikoyt-fiko-filitreci [(sablon)]="filitreciSablon"
                               [parametreModu]="true"
                               [temelAlanlarEkle]="true"
                               [kartParametreleri]="tumParametreler"
                               [bilesenTipleri]="bilesenTipleri"
                               [dinamikBilesenSetleri]="dinamikBilesenSetleri"
                               [siralamalar]="siralamalar"
                               [siralama]="aktifSiralama"
                               (siralamaDegisti)="siralamaDegisti($event)"
                               (enterBasildi)="filtreUygula()"
                               (uygulaBasildi)="filtreUygula()"
                               (temizleBasildi)="filtreTemizle()">
        </fikoyt-fiko-filitreci>
        <div style="display: flex; gap: 4px; margin-bottom: 4px;">
            <button nz-button
                    nzSize="small"
                    nzType="dashed"
                    (click)="topluIslemModuAcKapa();">
                <i class="check square outline icon"></i>
                {{ topluIslemModu ? 'Seçimi Kapat' : 'Toplu İşlem' }}
            </button>
        </div>

        @if (topluIslemModu) {
        <div
             style="display: flex; align-items: center; gap: 8px; padding: 8px; background: var(--py-arkaplan-hover); border: 1px solid var(--py-kenarlik-aktif); border-radius: 6px; margin-top: 4px;">
            <label nz-checkbox
                   [nzChecked]="seciliSayi === listeIstek.liste.length && listeIstek.liste.length > 0"
                   (nzCheckedChange)="tumunuSec()">
                Tümü
            </label>
            <span style="font-size: 12px; color: var(--py-link); font-weight: 600;">{{ seciliSayi }} seçili</span>
            <span style="flex: 1;"></span>
            <button nz-button
                    nzSize="small"
                    nzType="default"
                    [disabled]="seciliSayi === 0 || topluIslemMesgul"
                    (click)="topluEtiketle('Önemli')">
                <i class="tag icon"></i> Etiketle
            </button>
            <button nz-button
                    nzSize="small"
                    nzType="primary"
                    nzDanger
                    [disabled]="seciliSayi === 0 || topluIslemMesgul"
                    nz-popconfirm
                    nzPopconfirmTitle="Seçili kartlar silinecek, emin misiniz?"
                    (nzOnConfirm)="topluSil()">
                <i class="trash icon"></i> Sil ({{ seciliSayi }})
            </button>
        </div>
        }
    </div>

    <div class="w-full pt-3"
         style="max-width: 480px;">

        @defer (on timer(0)) {
        @if (listeIstek.liste.length < 1)
          {
          <div
          class="ui placeholder segment">
            <div class="ui icon header">
                @if (listeIstek.mesgul) {
                <i class="spinner loading icon"></i>
                } @else {
                <i class="share alternate icon"></i>
                }
                {{ listeIstek.mesgul ? 'Okunuyor...' : 'Henüz Paylaşım Yok' }}
            </div>
    </div>
    } @else {
    @if (listeIstek.mesgul) {
    <div style="text-align: center; padding: 8px 0; color: var(--py-metin-ucuncul); font-size: 12px;">
        <i class="spinner loading icon"></i> Güncelleniyor...
    </div>
    }
    @for (k of listeIstek.liste ?? []; track k._id) {
    <div style="display: flex; align-items: flex-start; gap: 4px;">
        @if (topluIslemModu) {
        <label nz-checkbox
               [nzChecked]="kartSeciliMi(k._id)"
               (nzCheckedChange)="kartSecimDegistir(k._id, $event)"
               style="margin-top: 16px;"></label>
        }
        <fikoyt-kart-kok [kart]="k"
                         style="flex: 1;"
                         [kartParametreSetleri]="tumParametreSetleri"
                         (kartGuncellendi)="kartYerineKoy($event)"></fikoyt-kart-kok>
    </div>
    }

    @if (listeIstek.sayfalama.sayi) {
    <nz-row nzJustify="center"
            class="paylasim-sayfalayici"
            style="margin-top: 1em;position: -webkit-sticky;position: sticky;">
        <div
             style="row-gap: 10px;width: 100%;display: flex;flex-wrap: wrap;justify-content: end;column-gap: 10px;margin-right:1em;">

            <nz-pagination #sayfalayici
                           [nzSimple]="false"
                           [nzTotal]="listeIstek.sayfalama.toplamKayitSayisi"
                           style="background: var(--py-sayfalama-arka);padding: 0px 10px;border-radius: 2em;box-shadow: var(--py-sayfalama-golge);"
                           [nzPageSize]="listeIstek.sayfalama.sayi"
                           (nzPageSizeChange)="listeIstek.sayiDegistir($event);"
                           nzSize="small"
                           [nzPageSizeOptions]="[5, 10, 15, 20]"
                           [nzPageIndex]="listeIstek.sayfalama.sayfa"
                           (nzPageIndexChange)="listeIstek.sayfaDegistir($event);"
                           nzShowSizeChanger
                           nzShowQuickJumper
                           [nzDisabled]="listeIstek.mesgul"></nz-pagination>
        </div>
    </nz-row>
    }
    }
    } @placeholder {
    <div class="ui placeholder segment">
        <div class="ui icon header">
            <i class="spinner loading icon"></i>
            Paylaşımlar Alınıyor
        </div>
    </div>
    } @loading {
    <div class="ui placeholder segment">
        <div class="ui icon header">
            <i class="spinner loading icon"></i>
            Paylaşımlar Alınıyor
        </div>
    </div>
    } @error {
    <div class="ui placeholder segment">
        <div class="ui icon header">
            <i class="exclamation triangle icon"></i> Paylaşımlar yüklenemedi.
        </div>
    </div>
    }
</div>
</div>